import React from "react";
import { connect } from "react-redux";
import SearchIcon from "../../assets/img/searchIcon";
import socket from "../../assets/socketConnection";
import CloseSVG from "../../assets/img/close";
import { createStructuredSelector } from "reselect";
import {
  fetchSuggestionsAsync,
  fetchSuggestionsSuccess,
  setSuggestionsShow,
} from "../../redux/map/map.actions";
import { selectMapCenterOfMapAddress } from "../../redux/map/map.selectors";
import { SearchBoxStyled, CloseBtn } from "./searchBox.styles";
import "../../app/App.css";

const SearchBox = ({
  fetchSuggestionsAsync,
  fetchSuggestionsSuccess,
  setInputValue,
  setListIsloading,
  selectMapCenterOfMapAddress,
  setSuggestionsShow,
  inputValue,
}) => {
  console.log("inputValue", inputValue.length);
  let timer,
    timeoutVal = 1000; // time it takes to wait for user to stop typing in ms
  const { ostan, shahr, address } = selectMapCenterOfMapAddress;
  function handleKeyPress(e) {
    if (e.currentTarget.value.length < 3) {
      // fetchSuggestionsSuccess([]);
      return;
    }
    // debugger;
    setListIsloading(true);
    window.clearTimeout(timer);
    // status.innerHTML = "Typing...";
    // alert("key press");
  }

  // when the user has stopped pressing on keys, set the timeout
  // if the user presses on keys before the timeout is reached, then this timeout is canceled
  function handleKeyUp(e) {
    const value = e.currentTarget.value;
    if (value.length < 3) {
      fetchSuggestionsSuccess([]);

      return;
    }

    // debugger;
    window.clearTimeout(timer); // prevent errant multiple timeouts from being generated
    timer = window.setTimeout(() => {
      // alert("key up");
      handle_input_change(value);
      setListIsloading(false);
      // status.innerHTML =
      //   "All done typing! Do stuff like save content to DB, send WebSocket message to server, etc.";
    }, timeoutVal);
  }

  const handle_input_change = (e) => {
    const value = e;
    // debugger;
    // alert("hi");
    // if (value.length < 3) {
    // fetchSuggestionsSuccess([]);
    // return;
    // }
    // debugger;
    fetchSuggestionsAsync(socket, value);
  };

  const handle_input_change2 = (e) => {
    const value = e.currentTarget.value;
    setInputValue(value);
    if (value.length >= 3) setSuggestionsShow(true);
  };

  return (
    <SearchBoxStyled>
      <input
        placeholder={shahr && `جستجو در استان ${ostan} شهر ${shahr}`}
        onChange={handle_input_change2}
        onKeyPress={handleKeyPress}
        onKeyUp={handleKeyUp}
        className="w-100 h-100"
        type="search"
        value={inputValue}
      />
      <div className="search-box__icon">
        {inputValue.length > 0 ? (
          <CloseBtn onClick={() => setInputValue("")} className="c-pointer">
            <CloseSVG />
          </CloseBtn>
        ) : (
          <SearchIcon width="24" height="24" />
        )}
      </div>
    </SearchBoxStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectMapCenterOfMapAddress: selectMapCenterOfMapAddress,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSuggestionsAsync: (x, y) => dispatch(fetchSuggestionsAsync(x, y)),
  fetchSuggestionsSuccess: (x) => dispatch(fetchSuggestionsSuccess(x)),
  setSuggestionsShow: (x) => dispatch(setSuggestionsShow(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);
